import { createSlice } from '@reduxjs/toolkit';
import { logOut as clearAuthToken } from '../../utils/jwt-helper';

export const initialState = {
  userInfo: {},
  orders: [],
};

export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    loadUserInfo: (state, action) => {
      return {
        ...state,
        userInfo: action?.payload,
      };
    },
    saveAddress: (state, action) => {
      const addresses = [...state?.userInfo?.addressList] ?? [];
      addresses.push(action?.payload);
      return {
        ...state,
        userInfo: {
          ...state?.userInfo,
          addressList: addresses,
        },
      };
    },
    removeAddress: (state, action) => {
      return {
        ...state,
        userInfo: {
          ...state?.userInfo,
          addressList: state?.userInfo?.addressList?.filter(
            (address) => address?.id !== action?.payload
          ),
        },
      };
    },
    loadOrders: (state, action) => {
      return {
        ...state,
        orders: action?.payload,
      };
    },
    cancelOrder: (state, action) => {
      return {
        ...state,
        orders: state?.orders?.map((order) => {
          if (order?.id === action?.payload) {
            return {
              ...order,
              orderStatus: 'CANCELLED',
            };
          }
          return order;
        }),
      };
    },
    logout: (state) => {
      // Clear user data
      return {
        ...state,
        userInfo: {},
        orders: [],
      };
    },
  },
});

export const { loadUserInfo, saveAddress, removeAddress, loadOrders, cancelOrder, logout } =
  userSlice?.actions;

// Thunk for logout that clears all user data
export const logoutUser = () => (dispatch) => {
  // Clear user data
  dispatch(logout());
  // Clear cart
  dispatch({ type: 'cartState/clearCart' });
  // Clear favorites
  dispatch({ type: 'favoritesState/clearFavorites' });
  clearAuthToken();
};

export const selectUserInfo = (state) => state?.userState?.userInfo ?? {};
export const selectAllOrders = (state) => state?.userState?.orders ?? [];
export const selectIsUserAdmin = (state) =>
  state?.userState?.userInfo?.authorityList?.some((authority) => authority?.roleCode === 'ADMIN');
export const selectIsUserStaff = (state) =>
  state?.userState?.userInfo?.authorityList?.some((authority) => authority?.roleCode === 'STAFF');

export default userSlice?.reducer;
